import { Component, Input, OnInit } from '@angular/core';
import * as Models from '../../../models/report-view.models';
import { Chart } from 'angular-highcharts';
import { HelpTextService } from '../../../services/help/helpText.service';
import { BillboardChartService } from '../../../services/billboard/billboard-chart.service';
import { billboardBarChartPlaceholder, billboardSplineChartPlaceholder } from '../../../constants/highcharts-placeholders';

@Component({
  selector: 'sd-billboard-benchmark',
  templateUrl: './billboard-benchmark.component.html',
  styleUrls: ['./billboard-benchmark.component.scss']
})
export class BillboardBenchmarkComponent implements Models.ElementComponent, OnInit {
  @Input() set dataSets(value: Models.DataSet[]) {
    this.isDataSetLoaded = !!value;
    if (!!value) {
      this.processData(value);
    }
  }

  isDataSetLoaded = false;

  @Input() settings: Models.ElementSettings;
  @Input() panelConfiguration?: Models.PanelConfiguration;

  metricValue;
  metricValuePreviousPeriod;
  metricValuePreviousYear;
  metricValuePOP;
  metricValueYOY;
  metricLabel;
  title;
  titleIconClasses;
  subtitleOne;
  subtitleOneLabel: string;
  subtitleTwo;
  subtitleTwoLabel: string;
  chart: Chart;
  metricValuePOPValue: number;
  metricValueYOYValue: number;

  placeholderChart: Chart;

  constructor(
    private helpTextService: HelpTextService,
    private billboardChartService: BillboardChartService,
  ) {
  }

  ngOnInit(): void {
    const chartType = this.settings.options?.['chart'] ?? 'bar';
    this.initializePlaceholder(chartType);
  }

  private processData(dataSets: Models.DataSet[]): void {
    let metricsDataSet: Models.DataSet;
    let chartDataSet: Models.DataSet;

    if (dataSets.length === 1) {
      metricsDataSet = dataSets[0];
      chartDataSet = dataSets[0];
    }
    else if (dataSets.length > 1) {
      metricsDataSet = dataSets[0];
      chartDataSet = dataSets[1];
    }

    let metricIndex = metricsDataSet.columns.findIndex(col => col.name === this.settings.metricName);
    let metricPreviousPeriodIndex = metricsDataSet.columns.findIndex(col => col.name === this.settings.metricNamePreviousPeriod);
    let metricPreviousYearIndex = metricsDataSet.columns.findIndex(col => col.name === this.settings.metricNamePreviousYear);
    let metricIndexPOP = metricsDataSet.columns.findIndex(col => col.name === this.settings.metricNamePOP);
    let metricIndexYOY = metricsDataSet.columns.findIndex(col => col.name === this.settings.metricNameYOY);

    this.metricValue = metricsDataSet.rows[0][metricIndex].label;
    this.metricValuePreviousPeriod = metricsDataSet.rows[0][metricPreviousPeriodIndex]?.label;
    this.metricValuePreviousYear = metricsDataSet.rows[0][metricPreviousYearIndex]?.label;
    this.metricValuePOPValue = metricsDataSet.rows[0][metricIndexPOP]?.value as number;
    this.metricValueYOYValue = metricsDataSet.rows[0][metricIndexYOY]?.value as number;
    this.metricValuePOP = metricsDataSet.rows[0][metricIndexPOP]?.label;
    this.metricValueYOY = metricsDataSet.rows[0][metricIndexYOY]?.label;
    this.title = this.settings.title ?? metricsDataSet.columns[metricIndex].displayName ?? metricsDataSet.columns[metricIndex].name;
    this.titleIconClasses = this.settings.titleIconClasses;
    this.subtitleOneLabel = "Prev. Period:";
    this.subtitleOne = this.metricValuePreviousPeriod;

    const chartType = this.settings.options?.["chart"] ?? 'bar';
    this.chart = this.billboardChartService.getBillboardChart(chartDataSet, this.settings.metricName, chartType, this.settings);
  }

  openHelpTextClicked(): void {
    this.helpTextService.openHelp(this.settings.helpTextKey, this.settings.helpTextTitle);
  }

  private initializePlaceholder(chartType: string): void {
    if (this.placeholderChart) {
      // exit if chart is already initialized
      return;
    }

    setTimeout(() => {
      switch (chartType) {
        case 'bar':
          this.placeholderChart = new Chart(billboardBarChartPlaceholder);
          break;
        case 'spline':
          this.placeholderChart = new Chart(billboardSplineChartPlaceholder);
          break;
        default:
          this.placeholderChart = new Chart(billboardBarChartPlaceholder);
      }
    }, 0);
  }
}
